<template>
  <Form v-slot="formSlot">
    <FormApiCapture :form-slot="formSlot" @update:api="formApi = $event" />
    <component :is="tag" @submit="onSubmit(formSlot, $event)">
      <slot v-bind="observerProps(formSlot)" />
    </component>
  </Form>
</template>
<script>
import { Form } from "vee-validate";
import FormApiCapture from "./FormApiCapture.vue";

export default {
  name: "ValidationObserver",
  components: { Form, FormApiCapture },
  props: {
    tag: { type: String, default: "div" },
  },
  data() {
    return { formApi: null };
  },
  methods: {
    observerProps(fp) {
      if (!fp) return {};
      const handleSubmit = (callback) => (e) => {
        e?.preventDefault?.();
        fp.validate().then((result) => {
          if (result.valid) callback(fp.getValues());
        });
      };
      return {
        handleSubmit,
        validate: fp.validate,
        invalid: !fp.meta?.valid,
        valid: fp.meta?.valid,
        errors: fp.errors,
        meta: fp.meta,
        submitForm: () => fp.submitForm(),
      };
    },
    onSubmit(formSlot, e) {
      // Always prevent the native form submission if present
      e?.preventDefault?.();

      if (formSlot?.validate) {
        formSlot.validate();
      }

      // Vue's `.prevent` modifier on `@submit` expects the first argument
      // to be an event-like object with a `preventDefault` function.
      // Emit a synthetic event so parent listeners using `@submit.prevent`
      // continue to work without runtime errors.
      const syntheticEvent = {
        preventDefault() {},
      };

      this.$emit("submit", syntheticEvent);
    },
    async validate() {
      // vee-validate 3's observer resolved a boolean; v4's FormApi resolves
      // {valid, errors}. Callers (and vue3-form-wizard's beforeChange, which
      // checks `=== true`) still expect the boolean.
      const result = await this.formApi?.validate?.();
      return result?.valid === true;
    },
  },
};
</script>
